import { gql } from '@apollo/client';

export default gql`
  query seatsPerTickets($departureDate: String!, $trainNumber: String!, $originUIC: String, $destinationUIC: String) {
    seatsPerTickets(departureDate: $departureDate, trainNumber: $trainNumber, originUIC: $originUIC, destinationUIC: $destinationUIC) {
      reference
      class
      seat
      coach
    }
  }
`;
